export function getApiChara() {
  let protocol = "https://";
  //let protocol = "https://";
  //let serverUrlPort = "localhost:8082/";
  //let serverUrlPort = "69.62.81.96:8080/";
  //let serverUrlPort = "192.168.1.102:8082/";
  //let serverUrlPort = "ZERO_BOOK_13:8082/";
  //let serverUrlPort = "10.64.234.198:8080/";
  let serverUrlPort = "drtechbuddy.in/api/";
  let mappingEndPoint = "api/hms/";
  let version = "v1";
  const ApiPara = protocol + serverUrlPort + mappingEndPoint + version;
  return ApiPara;
}

export function ApiCharLoader() {
  return getApiChara();
}
